function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, BackButton, Tabs, Tab, ExternalCreditDetailsTab, ExternalCreditHistoryTab } from 'components';
import { showApiError } from 'utils';
import { getExternalCredit } from 'services';
import { headerLeftTitle, headerLeftId } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ExternalCreditDetails = function ExternalCreditDetails(_ref) {
  var _location$state, _match$params, _externalCreditData$n;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      externalCredit = _ref2.externalCredit;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      externalCreditId = _ref3.externalCreditId;

  var _useState = useState(externalCredit),
      _useState2 = _slicedToArray(_useState, 2),
      externalCreditData = _useState2[0],
      setExternalCreditData = _useState2[1];

  useEffect(function () {
    fetchExternalCredit();
  }, []);

  var fetchExternalCredit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getExternalCre, _yield$getExternalCre2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getExternalCredit(externalCreditId);

            case 2:
              _yield$getExternalCre = _context.sent;
              _yield$getExternalCre2 = _slicedToArray(_yield$getExternalCre, 2);
              res = _yield$getExternalCre2[0];
              err = _yield$getExternalCre2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setExternalCreditData(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchExternalCredit() {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "2em",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/external-credit');
    }
  }), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "ID: ", externalCreditData === null || externalCreditData === void 0 ? void 0 : externalCreditData.id), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, (_externalCreditData$n = externalCreditData === null || externalCreditData === void 0 ? void 0 : externalCreditData.number) !== null && _externalCreditData$n !== void 0 ? _externalCreditData$n : '--')))), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    contentClass: "container",
    listClass: "container",
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/details",
    component: function component(data) {
      return ___EmotionJSX(ExternalCreditDetailsTab, _extends({}, data, {
        externalCredit: externalCreditData,
        onExternalCreditChange: function onExternalCreditChange(data) {
          return setExternalCreditData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), data);
          });
        }
      }));
    },
    label: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/history",
    component: function component(data) {
      return ___EmotionJSX(ExternalCreditHistoryTab, _extends({}, data, {
        history: externalCreditData === null || externalCreditData === void 0 ? void 0 : externalCreditData.history
      }));
    },
    label: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F"
  })));
};

ExternalCreditDetails.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default ExternalCreditDetails;